import React from 'react';
import Icon from './Icon';
const EmptyState = ({ icon = 'file', title, children }) => (
  <div className="empty-state">
    <span className="empty-state__icon">
      <Icon name={icon} size={27} />
    </span>
    <h3>{title}</h3>
    {children && <p>{children}</p>}
  </div>
);
export default EmptyState;
